import {
  CreateSupportTemplateRequest,
  UpdateSupportTemplateRequest,
  ViewSupportTemplateRequest
} from './support-template.types';

import {
  API_HOST,
  HttpGetOptions,
  HttpPostOptions,
  HttpPutOptions,
  getHttpGetOptions,
  getHttpPostOptions,
  getHttpPutOptions
} from '../../utils/api.util';

const getEndpoint = () => `${API_HOST}/support-template`;
const getSpecificEndpoint = (externalReference: string) => `${getEndpoint()}/${externalReference}`;

export const getCreateSupportTemplateRequest = (
  data: CreateSupportTemplateRequest
): [string, HttpPostOptions<CreateSupportTemplateRequest>] => [getEndpoint(), getHttpPostOptions(data)];

export const getViewSupportTemplateRequest = (data: ViewSupportTemplateRequest): [string, HttpGetOptions] => [
  getSpecificEndpoint(data.programmeExternalReference),
  getHttpGetOptions()
];

export const getUpdateSupportTemplateRequest = (
  data: UpdateSupportTemplateRequest
): [string, HttpPutOptions<UpdateSupportTemplateRequest>] => [getEndpoint(), getHttpPutOptions(data)];
